import { useState, useEffect } from "react";
import { FaArrowCircleLeft, FaUsers, FaTrash, FaPlusCircle, } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { showSuccess, showError, showWarning } from "../../General/Toast";
import Select from "react-select";
import { FaCamera } from "react-icons/fa";
import {  useLocation } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import { createPortal } from "react-dom";
import  "../../App.css"
import "../../App.css";
import "../../css/Party.css";

const PurchaseReturn = ({ clientData, setClientData, role }) => {
  const navigate = useNavigate();
const [invoiceDate, setInvoiceDate] = useState(
  new Date().toISOString().slice(0, 16)
);

  const location = useLocation();
  const editData = location.state;



  const [partyName, setPartyName] = useState("");
  const [showPartyForm, setShowPartyForm] = useState(false);
  const [discountInPercent, setDiscountInPercent] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedParty, setSelectedParty] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [party, setParty] = useState([]);
  const [unit, setunit] = useState([]);
  const [category, setCategory] = useState([]);
  const [isCredit, setIsCredit] = useState(true);
  const [itemModal, setItemModal] = useState(false);
  const [showPartyModal, setShowPartyModal] = useState(false);
  const [search, setSearch] = useState("");
  const [purchaseWithTax, setPurchaseWithTax] = useState(false);
  const [saleWithTax, setSaleWithTax] = useState(false);
  const [discountType, setDiscountType] = useState("amount");
  const [inventory, setInventory] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemSearch, setItemSearch] = useState("");
  const [discountValue, setDiscountValue] = useState(0);
  const [discountTypeUI, setDiscountTypeUI] = useState("amount");
  const [paidAmount, setPaidAmount] = useState(0);
  const [isFullyPaid, setIsFullyPaid] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState(0);
const [salePriceWithTax, setSalePriceWithTax] = useState(false);

  const [showItemForm, setShowItemForm] = useState(false);
   const [purPriceWithTax, setPurPriceWithTax] = useState(false);


const [units, setUnits] = useState([]);
  const [categories, setCategories] = useState([]);

const emptyProduct = {
  name: "",
  barcode: "",
  hsn_code: "",
  unit: "",
  category: "",
  mfgDate: "",
  expDate: "",
  mrp: "",
  wholesale: "",
  pur_price: "",
  pur_price_withTax: "Without Tax",
  sale_price: "",
  sale_price_withTax: "Without Tax",
  taxRate: "",
  discount: "",
  dis_in_percent: "Percent",
  stock: "",
  stock_at_price: "",
  min_to_maintain: "",
  stock_place: "",
  typeOfItem: "product",
  date: new Date().toISOString().split("T")[0],
  image: null,
  imagePreview: null,
};





  const [forms, setForms] = useState([{ ...emptyProduct }]);


  const [partyList, setPartyList] = useState([]);
const [formData, setFormData] = useState({
  name: '',
  first_visit: '',
  last_visit: '',
  mobile: '',
  email: "",
  total_pur: "",
  total_due: "",
  loyality: '',
  visits: "",
  gstin: '',
  gst_type: "Registered",
  gst_state: '',
  address: '',
  history: '',
  opening_balance: '',
  opening_bal_status: '',
  balance: '',
  asOfDate: '',
  p_type: '',
  client_id: '',
  invoiceNo: '',
  payment_method: ''
});
  // const [formData, setFormData] = useState({
  //   name: '',
  //   first_visit: '',
  //   last_visit: '',
  //   mobile: '',
  //   email: "",
  //   total_pur: "",
  //   total_due: "",
  //   loyality: '',
  //   visits: "",
  //   gstin: '',
  //   gst_type: "Registered",
  //   gst_state: '',
  //   address: '',
  //   history: '',
  //   opening_balance: '',
  //   opening_bal_status: '',
  //   balance: '',
  //   asOfDate: '',
  //   p_type: '',
  //   client_id: '',
  //   invoiceNo:'',
  //   payment_method:'Cash'
  // });

  const [modalItem, setModalItem] = useState({
    name: "",
    barcode: "",
    hsn_code: "",
    unit: "",
    category: "",
    purchase_price: 0,
    sale_price: 0,
    mrp: 0,
    wholesale_price: 0,
    qty: 1,
    taxRate: 0,
    taxMode: "GST",
    taxType: "Without Tax",
    discount: 0,
    pur_price_withTax: "With Tax",
    dis_in_percent: "Amount",
    sale_price_withTax: "With Tax"
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updated = { ...prev, [name]: value };

      return updated;
    });
  };

  const today = new Date().toISOString().split("T")[0];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.mobile) {
      showWarning("Name and Mobile are required!", "danger");
      return;
    }

    try {
      const today = new Date().toISOString().split("T")[0];


      const sendData = {
        name: formData.name,
        mobile: formData.mobile,
        gstin: formData.gstin,
        email: formData.email,

        gst_type: formData.gst_type,
        gst_state: formData.gst_state,
        address: formData.address,
        opening_balance: formData.opening_balance,
        asOfDate: formData.asOfDate,
        p_type: "Party",
        client_id: clientData.id,
        first_visit: today,
        last_visit: today,
        total_pur: 0,
        total_due: 0,
        loyality: 0,
        visits: 0,
        opening_bal_status: '',
        balance: 0,
      };

      let res;

      if (isEditMode) {

        const updateData = {
          name: formData.name,
          mobile: formData.mobile,
          gstin: formData.gstin,
          email: formData.email,
          gst_type: formData.gst_type,
          gst_state: formData.gst_state,
          address: formData.address,
        };

        res = await axios.put(
          `https://api.dectwinbilling.com/edit-party/${formData.id}`,
          updateData
        );

        showSuccess("Party Updated Successfully!", "success");
      } else {
        // 🔥 ADD MODE
        res = await axios.post(
          "https://api.dectwinbilling.com/add-party",
          sendData
        );

        showSuccess("Party Added Successfully!", "success");
      }

      // reset
      setIsEditMode(false);
      resetFormParty();
      setShowPartyForm(false);
      fetchparty();

    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);

      showError(
        err.response?.data?.message || "Failed to save party!",
        "danger"
      );
    }
  };

  const handleEdit = (form) => {

    setIsEditMode(true);
    setShowPartyForm(true);

    setFormData({
      id: form.id,
      name: form.name || "",
      mobile: form.mobile || "",
      email: form.email || "",
      gstin: form.gstin || "",
      gst_type: form.gst_type || "",
      gst_state: form.gst_state || "",
      address: form.address || "",
      opening_balance: form.opening_balance || "",
      asOfDate: form.as_of_date || "",
    });
  };
  const resetFormParty = () => {
    setFormData({
      name: '',
      first_visit: '',
      last_visit: '',
      mobile: '',
      email: "",
      total_pur: "",
      total_due: "",
      loyality: '',
      visits: "",
      gstin: '',
      gst_type: '',
      gst_state: '',
      address: '',
      history: '',
      opening_balance: '',
      opening_bal_status: '',
      balance: '',
      asOfDate: '',
      p_type: '',
      client_id: ''
    })

  }

  const fetchparty = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-party/${clientData.id}`);
      setPartyList(res.data);

    } catch (error) {
      console.log(error);
    }
  };


  const fetchInventory = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-inventory/${clientData.id}`);
      setInventory(res.data);


    } catch (error) {
      console.log(error);
    }
  };

  const fetchCategories = async () => {
  try {
    const response = await axios.get(
      `https://api.dectwinbilling.com/fetch-category/${clientData.id}`
    );

    setCategories(response.data);
  } catch (error) {
    console.log("Category Fetch Error:", error);
  }
};

const fetchUnits = async () => {
  try {
    const response = await axios.get(
      `https://api.dectwinbilling.com/fetch-unit/${clientData.id}`
    );

    setUnits(response.data);
  } catch (error) {
    console.log("Unit Fetch Error:", error);
  }
};

//  const itemOptions = inventory.map((item) => ({
//   value: item.id,
//   label: item.name,

//   price: Number(item.pur_price || 0),

//   category: item.category || "",
//   unit: item.unit || "",


//   stock: Number(item.stock || 0),

//   mrp: Number(item.mrp || 0),

//   barcode: item.barcode || "",
//   hsn_code: item.hsn_code || "",

//   taxRate: Number(item.taxRate || 0),
// }));
const itemOptions = inventory.map((item) => ({
  value: item.id,
  label: item.name,

  price: Number(item.pur_price || 0),

  category: item.category || "",
  unit: item.unit || "",

  stock: Number(item.stock || 0),
  mrp: Number(item.mrp || 0),

  barcode: item.barcode || "",
  hsn_code: item.hsn_code || "",

  // ⭐ TAX - original value preserve karo
  taxRate: item.taxRate ?? 0,
  taxMode: item.taxMode || "GST",

  taxType:
    item.taxType ||
    item.pur_price_withTax ||
    "Without Tax",

  pur_price_withTax:
    item.pur_price_withTax || "Without Tax",

  sale_price_withTax:
    item.sale_price_withTax || "Without Tax",
}));
  const fetchUnit = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-unit/${clientData.id}`);
      setunit(res.data);

    } catch (error) {
      console.log(error);
    }
  };

  const fetchCategory = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-category/${clientData.id}`);
      const filterCat =
        setCategory(res.data);

    } catch (error) {
      console.log(error);
    }
  };


  const fetchbankAccount = async () => {
    try {
      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-bank-accounts/${clientData.id}`
      );

      const data =
        typeof res.data === "string"
          ? JSON.parse(res.data)
          : res.data;

      setBankList(data);

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchparty();
    fetchUnit();
    fetchCategory();
    fetchInventory();
    fetchbankAccount();
    fetchUnits();
    fetchCategories();
  }, []);

  const [rows, setRows] = useState([
    {
      name: "",
      barcode: "",
      hsn_code: "",
      category: "",
      unit: "",
      pur_price: 0,
      sale_price: 0,
      taxRate: 0,
      qty: 0,
      taxType: "Without Tax",
    },
  ]);


  const addRow = () => {
    setRows([
      ...rows,
      {
        name: "",
        barcode: "",
        hsn_code: "",
        category: "",
        unit: "",
        pur_price: 0,
        sale_price: 0,
        taxRate: 0,
        qty: 0,
        stock:'',

        taxType: "Without Tax",
      },
    ]);
  };


//   const handleSelectItem = (item, rowIndex) => {
//   if (rowIndex === null || rowIndex === undefined) return;

//   setRows((prevRows) => {
//     const updatedRows = [...prevRows];

//     // =========================
//     // TAX RATE + GST / IGST
//     // =========================
//     const rawTaxRate = item.taxRate ?? 0;

//     let taxMode = item.taxMode || "GST";
//     let taxRate = 0;

//     const taxText = String(rawTaxRate).trim().toUpperCase();

//     // GST / IGST detect
//     if (taxText.includes("IGST")) {
//       taxMode = "IGST";
//     } else if (taxText.includes("GST")) {
//       taxMode = "GST";
//     }

//     // Rate detect: 5, 12, 18, GST-18, GST 18%, etc.
//     const rateMatch = taxText.match(/\d+(?:\.\d+)?/);

//     if (rateMatch) {
//       taxRate = Number(rateMatch[0]);
//     } else {
//       // agar backend me taxRate already number hai
//       const numericRate = Number(rawTaxRate);

//       if (!Number.isNaN(numericRate)) {
//         taxRate = numericRate;
//       }
//     }

//     // =========================
//     // WITH TAX / WITHOUT TAX
//     // =========================
//     const rawTaxType =
//       item.taxType ||
//       item.pur_price_withTax ||
//       item.sale_price_withTax ||
//       "Without Tax";

//     const taxTypeText = String(rawTaxType)
//       .trim()
//       .toLowerCase()
//       .replace(/[\s_-]/g, "");

//     const taxType =
//       taxTypeText === "withtax" ||
//       taxTypeText === "inclusive" ||
//       taxTypeText === "taxincluded"
//         ? "With Tax"
//         : "Without Tax";

//     // =========================
//     // PRICE
//     // =========================
//     const purchasePrice = Number(item.pur_price || 0);

//     const qty = Number(
//       updatedRows[rowIndex]?.qty || 1
//     );

//     // =========================
//     // SELECTED ITEM
//     // =========================
//     updatedRows[rowIndex] = {
//       ...updatedRows[rowIndex],

//       itemId: item.id,

//       name: item.name || "",
//       barcode: item.barcode || "",
//       hsn_code: item.hsn_code || "",
//       category: item.category || "",
//       unit: item.unit || "",

//       mrp: Number(item.mrp || 0),
//       pur_price: purchasePrice,
//       sale_price: Number(item.sale_price || 0),
//       wholesale: Number(item.wholesale || 0),

//       // ⭐⭐⭐ TAX FIX ⭐⭐⭐
//       taxMode: taxMode,
//       taxRate: taxRate,
//       taxType: taxType,

//       pur_price_withTax:
//         item.pur_price_withTax || taxType,

//       sale_price_withTax:
//         item.sale_price_withTax || taxType,

//       stock: Number(item.stock || 0),
//       stock_at_price: Number(item.stock_at_price || 0),
//       stock_place: item.stock_place || "",
//       min_to_maintain: Number(item.min_to_maintain || 0),

//       date:
//         item.date ||
//         new Date().toISOString(),

//       dis_in_percent:
//         item.dis_in_percent || "Amount",

//       discount: item.discount || "",

//       typeOfItem:
//         item.typeOfItem || "product",

//       qty: qty,

//       amount: purchasePrice * qty,
//     };

//     // =========================
//     // NEXT BLANK ROW
//     // =========================
//     if (rowIndex === updatedRows.length - 1) {
//       updatedRows.push({
//         id: Date.now(),

//         name: "",
//         barcode: "",
//         hsn_code: "",
//         category: "",
//         unit: "",

//         pur_price: 0,
//         sale_price: 0,
//         mrp: 0,
//         wholesale: 0,

//         qty: 1,

//         // ⭐ TAX DEFAULT
//         taxMode: "GST",
//         taxRate: 0,
//         taxType: "Without Tax",

//         pur_price_withTax: "Without Tax",
//         sale_price_withTax: "Without Tax",

//         discount: 0,
//         dis_in_percent: "Amount",

//         stock: 0,
//         stock_at_price: 0,
//         stock_place: "",

//         typeOfItem: "product",

//         amount: 0,
//       });
//     }

//     return updatedRows;
//   });

//   setItemModal(false);
//   setItemSearch("");
// };


const handleSelectItem = (item, rowIndex) => {

  if (rowIndex === null || rowIndex === undefined) return;

  setRows((prevRows) => {

    const updatedRows = [...prevRows];

    // =========================================================
    // PREVENT DUPLICATE ITEM
    // =========================================================

    const itemAlreadyExists = updatedRows.some(
      (row, index) =>
        index !== rowIndex &&
        Number(row.itemId) === Number(item.id)
    );

    if (itemAlreadyExists) {
      showWarning("This item is already selected.");
      return prevRows;
    }

    // =========================================================
    // TAX RATE + GST / IGST
    // =========================================================

    const rawTaxRate = item.taxRate ?? 0;

    let taxMode = item.taxMode || "GST";
    let taxRate = 0;

    const taxText = String(rawTaxRate)
      .trim()
      .toUpperCase();

    // GST / IGST detect
    if (taxText.includes("IGST")) {

      taxMode = "IGST";

    } else if (taxText.includes("GST")) {

      taxMode = "GST";
    }

    // Rate detect:
    // 5
    // 12
    // 18
    // GST-18
    // GST 18%
    const rateMatch = taxText.match(/\d+(?:\.\d+)?/);

    if (rateMatch) {

      taxRate = Number(rateMatch[0]);

    } else {

      // Backend me taxRate already number hai
      const numericRate = Number(rawTaxRate);

      if (!Number.isNaN(numericRate)) {
        taxRate = numericRate;
      }
    }

    // =========================================================
    // WITH TAX / WITHOUT TAX
    // =========================================================

    const rawTaxType =
      item.taxType ||
      item.pur_price_withTax ||
      item.sale_price_withTax ||
      "Without Tax";

    const taxTypeText = String(rawTaxType)
      .trim()
      .toLowerCase()
      .replace(/[\s\_-]/g, "");

    const taxType =
      taxTypeText === "withtax" ||
      taxTypeText === "inclusive" ||
      taxTypeText === "taxincluded"
        ? "With Tax"
        : "Without Tax";

    // =========================================================
    // PRICE
    // =========================================================

    const purchasePrice = Number(
      item.pur_price || 0
    );

    // IMPORTANT:
    // Do NOT default quantity to 1
    const qty = Number(
      updatedRows[rowIndex]?.qty || 1
    );

    // =========================================================
    // SELECTED ITEM
    // =========================================================

    updatedRows[rowIndex] = {

      ...updatedRows[rowIndex],

      itemId: item.id,

      name: item.name || "",

      barcode: item.barcode || "",

      hsn_code: item.hsn_code || "",

      category: item.category || "",

      unit: item.unit || "",

      mrp: Number(item.mrp || 0),

      pur_price: purchasePrice,

      sale_price: Number(
        item.sale_price || 0
      ),

      wholesale: Number(
        item.wholesale || 0
      ),

      // =====================================================
      // TAX
      // =====================================================

      taxMode: taxMode,

      taxRate: taxRate,

      taxType: taxType,

      pur_price_withTax:
        item.pur_price_withTax || taxType,

      sale_price_withTax:
        item.sale_price_withTax || taxType,

      // =====================================================
      // STOCK
      // =====================================================

      stock: Number(
        item.stock || 0
      ),

      stock_at_price: Number(
        item.stock_at_price || 0
      ),

      stock_place:
        item.stock_place || "",

      min_to_maintain: Number(
        item.min_to_maintain || 0
      ),

      date:
        item.date ||
        new Date().toISOString(),

      // =====================================================
      // DISCOUNT
      // =====================================================

      dis_in_percent:
        item.dis_in_percent || "Amount",

      discount:
        item.discount || "",

      typeOfItem:
        item.typeOfItem || "product",

      // =====================================================
      // QUANTITY
      // =====================================================

      qty: qty,

      amount:
        purchasePrice * qty,
    };

    // =========================================================
    // NEXT BLANK ROW
    // =========================================================

    if (
      rowIndex === updatedRows.length - 1
    ) {

      updatedRows.push({

        id: Date.now(),

        itemId: "",

        name: "",

        barcode: "",

        hsn_code: "",

        category: "",

        unit: "",

        pur_price: 0,

        sale_price: 0,

        mrp: 0,

        wholesale: 0,

        // IMPORTANT:
        // New row starts empty
        qty: "",

        // =====================================================
        // TAX DEFAULT
        // =====================================================

        taxMode: "GST",

        taxRate: 0,

        taxType: "Without Tax",

        pur_price_withTax:
          "Without Tax",

        sale_price_withTax:
          "Without Tax",

        // =====================================================
        // DISCOUNT
        // =====================================================

        discount: 0,

        dis_in_percent:
          "Amount",

        // =====================================================
        // STOCK
        // =====================================================

        stock: 0,

        stock_at_price: 0,

        stock_place: "",

        typeOfItem: "product",

        amount: 0,
      });
    }

    return updatedRows;
  });

  setItemModal(false);

  setItemSearch("");
};




  const handleAddNewItem = () => {
    handleSelectItem(modalItem, selectedRowIndex);

    setModalItem({
      name: "",
      barcode: "",
      hsn_code: "",
      unit: "",
      category: "",
      pur_price: "",
      qty: 1,
      taxRate: "",
      discount: "",
      sale_price: "",
      mrp: "",
      wholesale: "",
      pur_price_withTax: "Without Tax",
      sale_price_withTax: "Without Tax",
    });

    setItemSearch("");
  };

  const totalQty = rows.reduce(
    (sum, row) => sum + Number(row.qty || 0),
    0
  );

  const totalAmount = rows.reduce(
    (sum, row) =>
      sum + Number(row.pur_price || 0) * Number(row.qty || 0),
    0
  );


  const totalGST = rows.reduce((sum, row) => {
    const amount =
      Number(row.pur_price || 0) *
      Number(row.qty || 0);

    const gst =
      row.taxType === "Without Tax"
        ? (amount * Number(row.taxRate || 0)) / 100
        : 0;

    return sum + gst;
  }, 0);

  // const grandTotal = totalAmount + totalGST;
  const grandTotal = rows.reduce((sum, row) => {
    const amount =
      Number(row.pur_price || 0) *
      Number(row.qty || 0);

    const gst =
      row.taxType === "Without Tax"
        ? (amount * Number(row.taxRate || 0)) / 100
        : 0;

    return sum + amount + gst;
  }, 0);

  const handleRowChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };


  const getDiscountAmount = () => {
    const value = Number(discountValue || 0);

    if (discountTypeUI === "percent") {
      return (grandTotal * value) / 100;
    }
    return value;
  };

  const discountAmount = getDiscountAmount();

  const payableAmount = Math.max(grandTotal - discountAmount, 0);
  const paid = isFullyPaid ? payableAmount : Number(paidAmount || 0);
  const dueAmount = Math.max(payableAmount - Number(paidAmount || 0), 0);

  const filteredParty = (partyList || []).filter((p) => {
    const searchText = search.toLowerCase();

    return (
      (p.name || "").toLowerCase().includes(searchText) ||
      (p.mobile || "").toLowerCase().includes(searchText) ||
      (p.gstin || "").toLowerCase().includes(searchText) ||
      (p.address || "").toLowerCase().includes(searchText)
    );
  });


  // const handleSaveAndPrint = async () => {
  //   try {

  //     const isIGST = rows.some(
  //       (row) => row.taxMode === "IGST"
  //     );

  //     const sgst = isIGST ? 0 : totalGST / 2;
  //     const cgst = isIGST ? 0 : totalGST / 2;
  //     const igst = isIGST ? totalGST : 0;


  //     const paymentMethod = (formData.payment_method || "")
  //       .trim()
  //       .toLowerCase();


  //     const bankId =
  //       paymentMethod === "cash" ? 0 : Number(selectedBankId ?? 0);

  //     const payload = {
  //       invoice: clientData.purchase_no,
  //       cId: selectedParty?.id,
  //       cust_name: selectedParty?.name,
  //       cust_address: selectedParty?.address,
  //       cust_number: selectedParty?.mobile,
  //       gstin: selectedParty?.gstin,
  //       dateTime: invoiceDate,
  //       payable: payableAmount,
  //       recieved: paidAmount,
  //       due: dueAmount,



  //       items: rows.map((row) => {
  //         const amount =
  //           Number(row.qty || 0) * Number(row.pur_price || 0);

  //         const finalAmount =
  //           amount +
  //           (row.taxType === "Without Tax"
  //             ? (amount * Number(row.taxRate || 0)) / 100
  //             : 0);

  //         return {
  //           ...row,

  //           amount,

  //         };
  //       }),

  //       mode: isCredit ? "Online" : "Cash",
  //       payment_method: formData.payment_method || null,
  //       acc_id: bankId,
  //       itemsAdded: 0,

  //       sgst,
  //       cgst,
  //       igst,

  //       totalSP: 0,
  //       totalTax: totalGST,

  //       last_discount: discountValue,
  //       last_discount_type:
  //         discountTypeUI === "percent"
  //           ? "Percentage"
  //           : "Amount",


  //       onChangeForDiscount:
  //         discountTypeUI === "percent"
  //           ? Number(discountValue || 0)
  //           : 0,

  //       client_type: role || "",


  //     };

  //     const response = await axios.post(
  //       `https://api.dectwinbilling.com/api/add-purchase-bill/${clientData.id}`,
  //       payload
  //     );


  //     showSuccess("Purchase bill saved successfully", 'success');
  //     resetForm();

  //   } catch (error) {
  //     console.error(error);

  //     showError(
  //       error.response?.data?.message ||
  //       "Failed to save purchase bill", "error"
  //     );
  //   }
  // };


  console.log(editData)
useEffect(() => {
  if (!editData) return;

  setSelectedParty({
  id: editData.party_id,
  name: editData.name,
  mobile: editData.mobile,
  address: editData.address,
  gstin: editData.gstin,
});


// setInvoiceDate(editData.date || "");
setInvoiceDate(
  editData.date
    ? String(editData.date).slice(0, 16)
    : new Date().toISOString().slice(0, 16)
);

  const parsed =
    typeof editData.items === "string"
      ? JSON.parse(editData.items)
      : editData.items;

const formattedRows = parsed.map((item, index) => ({
  id: index + 1,

  itemId: item.itemId,

  name: item.name,
  barcode: item.barcode || "",
  hsn_code: item.hsn_code || "",

  category: item.category,
  unit: item.unit,

  qty: Number(item.qty || 1),

  pur_price: Number(item.pur_price || 0),
  sale_price: Number(item.sale_price || 0),

  taxRate: Number(item.taxRate || 0),
  taxMode: item.taxMode || "GST",
  taxType: item.taxType || "Without Tax",

  discount: Number(item.discount || 0),
  amount: Number(item.amount || 0),
    stock: Number(item.stock || 0),
}));

  setRows(formattedRows);

  setFormData((prev) => ({
  ...prev,
  payment_method: editData.payment_method || "",
  seller_name:editData.seller || '',
  invoiceNo:editData.invoiceNo ||'',
}));

setSelectedBankId(Number(editData.cb_payid || 0));

setPaidAmount(Number(editData.received || 0));

setDiscountTypeUI(
  editData.last_discount_type === "Percentage"
    ? "percent"
    : "amount"
);

setDiscountValue(Number(editData.last_discount || 0));


}, [editData]);


//   const handleSaveAndPrint = async () => {
//   try {
//     const isIGST = rows.some((row) => row.taxMode === "IGST");

//     const sgst = isIGST ? 0 : totalGST / 2;
//     const cgst = isIGST ? 0 : totalGST / 2;
//     const igst = isIGST ? totalGST : 0;

//     // const paymentMethod = formData.payment_method || ""
//   const paymentMethod =
//   formData.payment_method === "Cash"
//     ? "Cash"
//     : formData.payment_method || "";

//   //   const accountId = editData
//   // ? Number(editData?.acc_id || selectedBankId || 0)
//   // : Number(bankId || 0);

//   const accountId = editData
//   ? Number(editData.cb_payid || selectedBankId || 0)
//   : Number(selectedBankId || 0);

//     const bankId =
//       paymentMethod === "cash" ? 0 : Number(selectedBankId ?? 0);

//     const payload = {

//       cId: selectedParty?.id,
//       cust_name: selectedParty?.name,
//       cust_address: selectedParty?.address,
//       cust_number: selectedParty?.mobile,
//       gstin: selectedParty?.gstin,
//       dateTime: invoiceDate,
//       payable: payableAmount,
//       recieved: paidAmount,
//       due: dueAmount,
// items: rows.map((row) => ({
//   ...row,

//   // Inventory ka current stock
//   stock: Number(row.stock || 0),

//   // Purchase quantity
//   qty: Number(row.qty || 0),

//   amount:
//     Number(row.qty || 0) *
//     Number(row.pur_price || 0),
// })),
//       // items: rows.map((row) => ({
//       //   ...row,
//       //   amount: Number(row.qty || 0) * Number(row.pur_price || 0),
//       // })),

//       mode: isCredit ? "Online" : "Cash",
//       payment_method: paymentMethod,
//       // acc_id:editData?.selectedBankId ||  bankId,
//       acc_id:accountId,
//       itemsAdded: editData?.itemsAdded ?? 0,

//       sgst,
//       cgst,
//       igst,
//       totalSP: 0,
//       totalTax: totalGST,

//       last_discount: discountValue,
//       last_discount_type:
//         discountTypeUI === "percent"
//           ? "Percentage"
//           : "Amount",

//       onChangeForDiscount:
//         discountTypeUI === "percent"
//           ? Number(discountValue || 0)
//           : 0,

//       client_type: role || "",


//         invoiceNo: editData?.invoiceNo,
//   last_edited: new Date().toISOString(),
//   last_edited_by: clientData.id,
//   last_edited_type: clientData.role || "Admin",

//   totalMrp:0,
//     };

//     if (editData) {
//       // UPDATE
//   const res =   await axios.put(
//         `https://api.dectwinbilling.com/api/update-purchase-bill/${clientData.id}`,
//         payload
//       );

//       showSuccess("Purchase bill updated successfully",);
//       // navigate('/purchase')

//          navigate("/invoice-preview", {
//     state: {
//       invoice: {
//         ...payload,
//         invoiceNo:
//           res.data?.invoiceNo ||
//           res.data?.data?.invoiceNo
//       },
//        billTitle: "PURCHASE INVOICE"
//     }
//   });
//     } else {
//       // ADD
//    const res =  await axios.post(
//         `https://api.dectwinbilling.com/api/add-purchase-bill/${clientData.id}`,
//         payload
//       );

//       showSuccess("Purchase bill saved successfully", "success");

//           navigate("/invoice-preview", {
//     state: {
//       invoice: {
//         ...payload,
//         invoiceNo:
//           res.data?.invoiceNo ||
//           res.data?.data?.invoiceNo
//       },
//        billTitle: "PURCHASE INVOICE"
//     }
//   });
//     }

//     resetForm();
//   } catch (error) {
//     console.error(error);

//     showError(
//       error.response?.data?.message || "Operation failed",
//       "error"
//     );
//   }
// };
// const handleSaveAndPrint = async () => {
//   try {
//     // ---------------------------------------
//     // PAYMENT METHOD
//     // ---------------------------------------
//     const paymentMethod = isCredit
//       ? String(formData.payment_method || "").trim()
//       : "Cash";

//     // Credit mode me Payment Method compulsory
//     if (isCredit && !paymentMethod) {
//       showWarning(
//         "Please select payment method to proceed.",
//         "warning"
//       );
//       return;
//     }

//     // ---------------------------------------
//     // GST
//     // ---------------------------------------
//     const isIGST = rows.some(
//       (row) => row.taxMode === "IGST"
//     );

//     const sgst = isIGST ? 0 : totalGST / 2;
//     const cgst = isIGST ? 0 : totalGST / 2;
//     const igst = isIGST ? totalGST : 0;

//     // ---------------------------------------
//     // BANK ACCOUNT
//     // ---------------------------------------
//     // Credit payment method ke liye selected bank
//     // use hoga, agar bank select kiya gaya hai.
//     const accountId = editData
//       ? Number(editData.cb_payid || selectedBankId || 0)
//       : Number(selectedBankId || 0);

//     const payload = {
//       // ---------------------------------------
//       // PARTY
//       // ---------------------------------------
//       cId: selectedParty?.id,
//       cust_name: selectedParty?.name,
//       cust_address: selectedParty?.address,
//       cust_number: selectedParty?.mobile,
//       gstin: selectedParty?.gstin,

//       // ---------------------------------------
//       // DATE / AMOUNT
//       // ---------------------------------------
//       dateTime: invoiceDate,
//       payable: payableAmount,
//       recieved: paidAmount,
//       due: dueAmount,

//       // ---------------------------------------
//       // ITEMS
//       // ---------------------------------------
//       items: rows.map((row) => ({
//         ...row,

//         stock: Number(row.stock || 0),

//         qty: Number(row.qty || 0),

//         amount:
//           Number(row.qty || 0) *
//           Number(row.pur_price || 0),
//       })),

//       // ---------------------------------------
//       // PAYMENT
//       // ---------------------------------------
//       mode: isCredit ? "Online" : "Cash",

//       // IMPORTANT:
//       // Credit -> UPI / Credit Card / Debit Card
//       // Cash   -> Cash
//       payment_method: paymentMethod,

//       acc_id: accountId,

//       itemsAdded: editData?.itemsAdded ?? 0,

//       // ---------------------------------------
//       // GST
//       // ---------------------------------------
//       sgst,
//       cgst,
//       igst,

//       totalSP: 0,
//       totalTax: totalGST,

//       // ---------------------------------------
//       // DISCOUNT
//       // ---------------------------------------
//       last_discount: discountValue,

//       last_discount_type:
//         discountTypeUI === "percent"
//           ? "Percentage"
//           : "Amount",

//       onChangeForDiscount:
//         discountTypeUI === "percent"
//           ? Number(discountValue || 0)
//           : 0,

//       // ---------------------------------------
//       // CLIENT
//       // ---------------------------------------
//       client_type: role || "",

//       // ---------------------------------------
//       // EDIT INFO
//       // ---------------------------------------
//       invoiceNo: editData?.invoiceNo,

//       last_edited: new Date().toISOString(),

//       last_edited_by: clientData.id,

//       last_edited_type:
//         clientData.role || "Admin",

//       totalMrp: 0,
//     };

//     console.log(
//       "FINAL PAYMENT PAYLOAD:",
//       payload
//     );

//     // ---------------------------------------
//     // UPDATE
//     // ---------------------------------------
//     if (editData) {
//       const res = await axios.put(
//         `https://api.dectwinbilling.com/api/update-purchase-bill/${clientData.id}`,
//         payload
//       );

//       showSuccess(
//         "Purchase bill updated successfully",
//         "success"
//       );

//       navigate("/invoice-preview", {
//         state: {
//           invoice: {
//             ...payload,

//             invoiceNo:
//               res.data?.invoiceNo ||
//               res.data?.data?.invoiceNo ||
//               editData?.invoiceNo,
//           },

//           billTitle: "PURCHASE INVOICE",
//         },
//       });
//     }

//     // ---------------------------------------
//     // ADD
//     // ---------------------------------------
//     else {
//       const res = await axios.post(
//         `https://api.dectwinbilling.com/api/add-purchase-bill/${clientData.id}`,
//         payload
//       );

//       showSuccess(
//         "Purchase bill saved successfully",
//         "success"
//       );

//       navigate("/invoice-preview", {
//         state: {
//           invoice: {
//             ...payload,

//             invoiceNo:
//               res.data?.invoiceNo ||
//               res.data?.data?.invoiceNo,
//           },

//           billTitle: "PURCHASE INVOICE",
//         },
//       });
//     }

//     // ---------------------------------------
//     // RESET
//     // ---------------------------------------
//     resetForm();

//   } catch (error) {
//     console.error(
//       "Purchase Save Error:",
//       error
//     );

//     showError(
//       error.response?.data?.message ||
//         "Operation failed",
//       "error"
//     );
//   }
// };
// const handleSaveAndPrint = async () => {
//   try {
//     // ---------------------------------------
//     // PAYMENT METHOD
//     // ---------------------------------------
//     const paymentMethod = isCredit
//       ? String(formData.payment_method || "").trim()
//       : "Cash";

//     if (isCredit && !paymentMethod) {
//       showWarning(
//         "Please select payment method to proceed.",
//         "warning"
//       );
//       return;
//     }

//     // ---------------------------------------
//     // VALID ITEMS
//     // ---------------------------------------
//     const validRows = rows.filter((row) => {
//       const hasItem =
//         row.itemId ||
//         String(row.name || "").trim();

//       const hasQty = Number(row.qty || 0) > 0;

//       return hasItem && hasQty;
//     });

//     // No item selected
//     if (validRows.length === 0) {
//       showWarning(
//         "Please select at least one item to proceed.",
//         "warning"
//       );
//       return;
//     }

//     // ---------------------------------------
//     // GST
//     // ---------------------------------------
//     const isIGST = validRows.some(
//       (row) => row.taxMode === "IGST"
//     );

//     const validGST = validRows.reduce((sum, row) => {
//       const amount =
//         Number(row.pur_price || 0) *
//         Number(row.qty || 0);

//       const gst =
//         row.taxType === "Without Tax"
//           ? (amount * Number(row.taxRate || 0)) / 100
//           : 0;

//       return sum + gst;
//     }, 0);

//     const sgst = isIGST ? 0 : validGST / 2;
//     const cgst = isIGST ? 0 : validGST / 2;
//     const igst = isIGST ? validGST : 0;

//     // ---------------------------------------
//     // BANK ACCOUNT
//     // ---------------------------------------
//     const accountId = editData
//       ? Number(
//           editData.cb_payid ||
//           selectedBankId ||
//           0
//         )
//       : Number(selectedBankId || 0);

//     // ---------------------------------------
//     // ITEMS
//     // ONLY FILLED ROWS WILL BE SAVED/PRINTED
//     // ---------------------------------------
//     const validItems = validRows.map((row) => ({
//       ...row,

//       stock: Number(row.stock || 0),

//       qty: Number(row.qty || 0),

//       amount:
//         Number(row.qty || 0) *
//         Number(row.pur_price || 0),
//     }));

//     // ---------------------------------------
//     // PAYLOAD
//     // ---------------------------------------
//     const payload = {
//       // PARTY
//       cId: selectedParty?.id,
//       cust_name: selectedParty?.name,
//       cust_address: selectedParty?.address,
//       cust_number: selectedParty?.mobile,
//       gstin: selectedParty?.gstin,

//       // DATE / AMOUNT
//       dateTime: invoiceDate,
//       payable: payableAmount,
//       recieved: paidAmount,
//       due: dueAmount,

//       // ONLY FILLED ITEMS
//       items: validItems,

//       // PAYMENT
//       mode: isCredit ? "Online" : "Cash",
//       payment_method: paymentMethod,
//       acc_id: accountId,

//       itemsAdded: editData?.itemsAdded ?? 0,

//       // GST
//       sgst,
//       cgst,
//       igst,

//       totalSP: 0,
//       totalTax: validGST,

//       // DISCOUNT
//       last_discount: discountValue,

//       last_discount_type:
//         discountTypeUI === "percent"
//           ? "Percentage"
//           : "Amount",

//       onChangeForDiscount:
//         discountTypeUI === "percent"
//           ? Number(discountValue || 0)
//           : 0,

//       // CLIENT
//       client_type: role || "",

//       // EDIT INFO
//       invoiceNo: editData?.invoiceNo,

//       last_edited: new Date().toISOString(),

//       last_edited_by: clientData.id,

//       last_edited_type:
//         clientData.role || "Admin",

//       totalMrp: 0,
//     };

//     console.log(
//       "FINAL PURCHASE PAYLOAD:",
//       payload
//     );

//     // ---------------------------------------
//     // UPDATE
//     // ---------------------------------------
//     if (editData) {
//       const res = await axios.put(
//         `https://api.dectwinbilling.com/api/update-purchase-bill/${clientData.id}`,
//         payload
//       );

//       showSuccess(
//         "Purchase bill updated successfully",
//         "success"
//       );

//       navigate("/invoice-preview", {
//         state: {
//           invoice: {
//             ...payload,

//             invoiceNo:
//               res.data?.invoiceNo ||
//               res.data?.data?.invoiceNo ||
//               editData?.invoiceNo,
//           },

//           billTitle: "PURCHASE INVOICE",
//         },
//       });
//     }


//     else {
//       const res = await axios.post(
//         `https://api.dectwinbilling.com/api/add-purchase-bill/${clientData.id}`,
//         payload
//       );

//       showSuccess(
//         "Purchase bill saved successfully",
//         "success"
//       );

//       navigate("/invoice-preview", {
//         state: {
//           invoice: {
//             ...payload,

//             invoiceNo:
//               res.data?.invoiceNo ||
//               res.data?.data?.invoiceNo,
//           },

//           billTitle: "PURCHASE INVOICE",
//         },
//       });
//     }

//     resetForm();

//   } catch (error) {
//     console.error(
//       "Purchase Save Error:",
//       error
//     );

//     showError(
//       error.response?.data?.message ||
//         "Operation failed",
//       "error"
//     );
//   }
// };
const handleSaveAndPrint = async () => {
  try {
    // ---------------------------------------
    // PARTY VALIDATION
    // ---------------------------------------
    if (
      !selectedParty ||
      !selectedParty.id ||
      !String(selectedParty.name || "").trim()
    ) {
      showWarning(
        "Please add party detail first in order to make purchase.",
        "warning"
      );
      return;
    }

    // ---------------------------------------
    // PAYMENT METHOD
    // ---------------------------------------
    const paymentMethod = isCredit
      ? String(formData.payment_method || "").trim()
      : "Cash";

    if (isCredit && !paymentMethod) {
      showWarning(
        "Please select payment method to proceed.",
        "warning"
      );
      return;
    }

    // ---------------------------------------
    // VALID ITEMS
    // ---------------------------------------
    const validRows = rows.filter((row) => {
      const hasItem =
        row.itemId ||
        String(row.name || "").trim();

      const hasQty = Number(row.qty || 0) > 0;

      return hasItem && hasQty;
    });

    if (validRows.length === 0) {
      showWarning(
        "Please select at least one item to proceed.",
        "warning"
      );
      return;
    }

    // ---------------------------------------
    // GST
    // ---------------------------------------
    const isIGST = validRows.some(
      (row) => row.taxMode === "IGST"
    );

    const validGST = validRows.reduce((sum, row) => {
      const amount =
        Number(row.pur_price || 0) *
        Number(row.qty || 0);

      const gst =
        row.taxType === "Without Tax"
          ? (amount * Number(row.taxRate || 0)) / 100
          : 0;

      return sum + gst;
    }, 0);

    const sgst = isIGST ? 0 : validGST / 2;
    const cgst = isIGST ? 0 : validGST / 2;
    const igst = isIGST ? validGST : 0;

    // ---------------------------------------
    // BANK ACCOUNT
    // ---------------------------------------
    const accountId = editData
      ? Number(
          editData.cb_payid ||
          selectedBankId ||
          0
        )
      : Number(selectedBankId || 0);

    // ---------------------------------------
    // ONLY FILLED ITEMS
    // ---------------------------------------
    const validItems = validRows.map((row) => ({
      ...row,

      stock: Number(row.stock || 0),

      qty: Number(row.qty || 0),

      amount:
        Number(row.qty || 0) *
        Number(row.pur_price || 0),
    }));

    // ---------------------------------------
    // PAYLOAD
    // ---------------------------------------
    const payload = {
      // PARTY
      cId: Number(selectedParty.id),
      cust_name: selectedParty.name || "",
      cust_address: selectedParty.address || "",
      cust_number: selectedParty.mobile || "",
      gstin: selectedParty.gstin || "",

      // DATE / AMOUNT
      dateTime: invoiceDate,
      payable: payableAmount,
      recieved: paidAmount,
      due: dueAmount,

      // ITEMS
      items: validItems,

      // PAYMENT
      mode: isCredit ? "Online" : "Cash",
      payment_method: paymentMethod,
      acc_id: accountId,

      itemsAdded: editData?.itemsAdded ?? 0,

      // GST
      sgst,
      cgst,
      igst,

      totalSP: 0,
      totalTax: validGST,

      // DISCOUNT
      last_discount: discountValue,

      last_discount_type:
        discountTypeUI === "percent"
          ? "Percentage"
          : "Amount",

      onChangeForDiscount:
        discountTypeUI === "percent"
          ? Number(discountValue || 0)
          : 0,

      // CLIENT
      client_type: role || "",

      // EDIT INFO
      invoiceNo: editData?.invoiceNo,

      last_edited: new Date().toISOString(),

      last_edited_by: clientData.id,

      last_edited_type:
        clientData.role || "Admin",

      totalMrp: 0,
    };

    console.log(
      "FINAL PURCHASE PAYLOAD:",
      payload
    );

    // ---------------------------------------
    // UPDATE
    // ---------------------------------------
    if (editData) {
      const res = await axios.put(
        `https://api.dectwinbilling.com/api/update-purchase-bill/${clientData.id}`,
        payload
      );

      showSuccess(
        "Purchase bill updated successfully",
        "success"
      );

      navigate("/invoice-preview", {
        state: {
          invoice: {
            ...payload,

            invoiceNo:
              res.data?.invoiceNo ||
              res.data?.data?.invoiceNo ||
              editData?.invoiceNo,
          },

          billTitle: "PURCHASE INVOICE",
        },
      });
    }

    // ---------------------------------------
    // ADD
    // ---------------------------------------
    else {
      const res = await axios.post(
        `https://api.dectwinbilling.com/api/add-purchase-bill/${clientData.id}`,
        payload
      );

      showSuccess(
        "Purchase bill saved successfully",
        "success"
      );

      navigate("/invoice-preview", {
        state: {
          invoice: {
            ...payload,

            invoiceNo:
              res.data?.invoiceNo ||
              res.data?.data?.invoiceNo,
          },

          billTitle: "PURCHASE INVOICE",
        },
      });
    }

    resetForm();

  } catch (error) {
    console.error(
      "Purchase Save Error:",
      error
    );

    showError(
      error.response?.data?.message ||
        "Operation failed",
      "error"
    );
  }
};
  const resetForm = () => {

    setSelectedParty(null);

    setRows([
      {
        name: "",
        qty: 1,
        pur_price: 0,
        sale_price: 0,
        discount: 0,
        taxRate: "",
        taxMode: "",
        taxType: "Without Tax",
        unit: "",
        category: "",
        amount: 0,
      },
    ]);

    // Payment
    setPaidAmount(0);
    setIsFullyPaid(false);

    // Credit / Cash
    setIsCredit(false);
    setSelectedBankId("");

    // Discount
    setDiscountValue(0);
    setDiscountTypeUI("amount");

    // Form data (FULL RESET)
    setFormData({
      payment_method: "",
      name: "",
      mobile: "",
      gstin: "",
      email: "",
      gst_type: "",
      gst_state: "",
      address: "",
      opening_balance: "",
      asOfDate: "",
      sale_price: "",
      discount: "",
    });

    // Modal states
    setItemModal(false);
    setItemSearch("");
    setModalItem({
      name: "",
      barcode: "",
      hsn_code: "",
      unit: "",
      category: "",
      pur_price: 0,
      sale_price: 0,
      qty: 1,
      taxRate: "",
      taxMode: "",
      discount: 0,
      sale_price_withTax: "Without Tax",
      pur_price_withTax: "Without Tax",
      mrp: 0,
      wholesale: 0,
      dis_in_percent: "Amount",
    });

    // Tax toggles
    setPurchaseWithTax(false);
    setSaleWithTax(false);

    // Date FIX
    setInvoiceDate(new Date().toISOString().split("T")[0]);
  };

  const reactSelectStyles = (width) => ({
    container: (base) => ({
      ...base,
      width: width,
    }),

    control: (base) => ({
      ...base,
      minHeight: "36px",
      height: "36px",
      fontSize: "14px",
    }),

    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
    }),

    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
    }),

    menu: (base) => ({
      ...base,
      zIndex: 99999,
    }),
  });

  const selectPortalStyles = (width) => ({
    ...reactSelectStyles(width),

    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
    }),

    menu: (base) => ({
      ...base,
      zIndex: 99999,
    }),
  });


  //inventary part
//   const handleSubmitItem = async () => {
//   try {

//    for (const form of forms) {
//   if (!form.name?.trim()) {
//     continue;
//   }

//   const formData = new FormData();

//   Object.keys(form).forEach((key) => {
//     if (key !== "imagePreview") {
//       formData.append(
//         key,
//         form[key]
//       );

//     }

//   });

//   formData.append(
//     "client_id",
//   clientData.id
//   );

//   await axios.post(
//     "https://api.dectwinbilling.com/inventory/upsert",
//     formData,
//     {
//       headers: {
//         "Content-Type":
//           "multipart/form-data",
//       },
//     }
//   );

// }
//       showSuccess("Products added successfully");
//     setShowItemForm(false);
//     setForms([{ ...emptyProduct }]);
//     fetchInventory();
//   } catch (error) {
//     console.log(error);
//     showError(
//       error.response?.data?.message ||
//       "Something went wrong"
//     );

//   }
// };
// INVENTORY PART
const handleSubmitItem = async () => {
  try {
    // ---------------------------------------
    // VALIDATION
    // ---------------------------------------
    const validForms = forms.filter(
      (form) => form.name?.trim()
    );

    // Agar koi bhi product fill nahi hai
    if (validForms.length === 0) {
      showWarning(
        "Please fill product details first.",
        "warning"
      );
      return;
    }

    // Required fields validation
    for (const form of validForms) {
      if (!form.name?.trim()) {
        showWarning(
          "Item Name is required.",
          "warning"
        );
        return;
      }

      if (!form.mrp) {
        showWarning(
          "MRP Price is required.",
          "warning"
        );
        return;
      }

      if (!form.pur_price) {
        showWarning(
          "Purchase Price is required.",
          "warning"
        );
        return;
      }

      if (!form.sale_price) {
        showWarning(
          "Sale Price is required.",
          "warning"
        );
        return;
      }

      if (!form.stock) {
        showWarning(
          "Opening Quantity is required.",
          "warning"
        );
        return;
      }

      if (!form.stock_at_price) {
        showWarning(
          "At Price is required.",
          "warning"
        );
        return;
      }

      if (!form.min_to_maintain) {
        showWarning(
          "Min Stock is required.",
          "warning"
        );
        return;
      }

      if (!form.stock_place?.trim()) {
        showWarning(
          "Location is required.",
          "warning"
        );
        return;
      }
    }

    // ---------------------------------------
    // SAVE ONLY VALID PRODUCTS
    // ---------------------------------------
    for (const form of validForms) {
      const formData = new FormData();

      Object.keys(form).forEach((key) => {
        if (key !== "imagePreview") {
          formData.append(key, form[key] ?? "");
        }
      });

      formData.append(
        "client_id",
        clientData.id
      );

      await axios.post(
        "https://api.dectwinbilling.com/inventory/upsert",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    }

    // ---------------------------------------
    // SUCCESS
    // ---------------------------------------
    showSuccess(
      "Product added successfully",
      "success"
    );

    setShowItemForm(false);
    setForms([{ ...emptyProduct }]);
    fetchInventory();

  } catch (error) {
    console.log(error);

    showError(
      error.response?.data?.message ||
        "Something went wrong",
      "error"
    );
  }
};
const handleAddLess = () => {
  if (forms.length > 1) {
    setForms(forms.slice(0, -1));
  }
};


const handleImageChange = (index, e) => {
  const file = e.target.files[0];

  if (file) {
    const updatedForms = [...forms];

    updatedForms[index].image = file;
    updatedForms[index].imagePreview =
      URL.createObjectURL(file);

    setForms(updatedForms);
  }
};


const handleChange = (index, e) => {
  const updatedForms = [...forms];

  updatedForms[index] = {
    ...updatedForms[index],
    [e.target.name]: e.target.value,
  };

  setForms(updatedForms);
};

  return (
    <div
      className="page-wrapper "
    >

      <div
        className="page-header"
      >
        <FaArrowCircleLeft
          style={{
            cursor: "pointer",
          }}
          onClick={() => navigate("/purchase")}
        />

        <span>Purchase </span>
      </div>

      <div className="container-fluid pt-3">
  <div className="row g-3 ">

    {/* ================= Left Section ================= */}
      <div className={selectedParty ? "col-lg-4" : "col-lg-6"}>
      <div
  className="w-100 h-100 shadow-sm"
  style={{
    background: "#ece7e7",
    padding: "20px",
    borderRadius: "12px",
    maxWidth: "360px",
  }}
>

    {!editData && (
  <div className="d-flex flex-wrap gap-2 mb-3">
    <button
      type="button"
      className={`btn-credit ${
        isCredit ? "btn-warning" : "btn-success"
      }`}
      // onClick={() => setIsCredit(!isCredit)}
      onClick={() => {
  const nextCredit = !isCredit;

  setIsCredit(nextCredit);

  if (nextCredit) {
    // CREDIT selected
    // Payment method abhi user select karega
    setFormData((prev) => ({
      ...prev,
      payment_method: "",
    }));

    setSelectedBankId(0);
  } else {
    // CASH selected
    setFormData((prev) => ({
      ...prev,
      payment_method: "Cash",
    }));

    setSelectedBankId(0);
  }
}}

    >
      {isCredit ? "Credit" : "Cash"}
    </button>

    <button
      className="btn-party"
      onClick={() => setShowPartyForm(true)}
    >
      + Add Party
    </button>
  </div>
    )}


  {/* Party Name */}
  <div className="mb-3">
    <label className="form-label fw-bold">
      Party Name <span className="text-danger">*</span>
    </label>

    <input
      type="text"
      className="form-control"
      placeholder="Enter Party Name"
      value={selectedParty?.name || ""}
      readOnly
      onClick={() => setShowPartyModal(true)}
    />
  </div>

  {/* Invoice Date */}
  <div>
    <label className="form-label fw-bold">
      Invoice Date
    </label>

    <input
        type="datetime-local"
      value={invoiceDate}
      onChange={(e) => setInvoiceDate(e.target.value)}
      className="form-control"
    />
  </div>

  {editData && (
    <>
        <div className="mb-3">
          <label className="form-label fw-bold">
            Invoice No.
          </label>

          <input
            type="text"
            value={formData.invoiceNo}
            readOnly
            className="form-control"
          />
        </div>
    </>
  )}
</div>
    </div>

    {/* ================= Party Details ================= */}
    {selectedParty && !editData && (
      <div className="col-lg-4">
        <div
          className="w-100 h-100 shadow-sm"
          style={{
            background: "#ece7e7",
            padding: "20px",
            borderRadius: "12px",
          }}
        >
          <div className="text-center mb-3">
            <h5 className="fw-bold mb-1">Party Details</h5>
            <small className="text-muted">
              Selected Customer Information
            </small>
          </div>

          <div className="row g-2">

            <div className="col-6">
              <div className="bg-light rounded p-2 d-flex justify-content-between">
                <span className="text-muted">Visits</span>
                <strong>{selectedParty.first_visit ?? 0}</strong>
              </div>
            </div>

            <div className="col-6">
              <div className="bg-light rounded p-2 d-flex justify-content-between">
                <span className="text-muted">GSTIN</span>
                <strong>{selectedParty.gstin || "NA"}</strong>
              </div>
            </div>

            <div className="col-6">
              <div className="bg-light rounded p-2 d-flex justify-content-between">
                <span className="text-muted">Due</span>
                <strong className="text-danger">
                  ₹{selectedParty.total_due || 0}
                </strong>
              </div>
            </div>

            <div className="col-6">
              <div className="bg-light rounded p-2 d-flex justify-content-between">
                <span className="text-muted">Purchase</span>
                <strong className="text-success">
                  ₹{selectedParty.total_pur || 0}
                </strong>
              </div>
            </div>

          </div>
        </div>
      </div>
    )}



  </div>
</div>


{!editData && (
<div className="container-fluid pt-3">
<div className="row justify-content-end mt-3">
  <div className="col-auto">
    <button
      className="btn-credit"
      onClick={() => {
        setForms([{ ...emptyProduct }]);
        setShowItemForm(true);
      }}
    >
      <FaPlusCircle className="me-2" />
      Add Product
    </button>
  </div>
</div>
</div>
)}




  <div className="container-fluid mt-3">
  <div
        className="table-responsive  mt-2"
        style={{
          overflowX: "auto",
          overflowY: "hidden"
        }}
      >
        <table className="table table-bordered table-hover align-middle text-center">
          <thead>
            <tr >
              <th style={{ background: "var(--primary-color)", color: "#fff", height: "60px" }}>S.No.</th>
              <th style={{ background: "var(--primary-color)", color: "#fff", height: "60px" }}>Item Name</th>
              <th style={{ background: "var(--primary-color)", color: "#fff", height: "60px" }}>Category</th>
              <th style={{ background: "var(--primary-color)", color: "#fff", height: "60px" }}>Unit</th>
              <th style={{ background: "var(--primary-color)", color: "#fff", height: "60px" }}>Pur.Price/Unit</th>
              <th style={{ background: "var(--primary-color)", color: "#fff", height: "60px" }}>Quantity</th>
              <th style={{ background: "var(--primary-color)", color: "#fff", height: "60px" }}>Tax/Unit</th>
              <th style={{ background: "var(--primary-color)", color: "#fff", height: "60px" }}>Amount</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((row, index) => {

              const qty = Number(row.qty || 0);
              const price = Number(row.pur_price || 0);
              const taxRate = Number(row.taxRate || 0);

              const baseAmount = qty * price;

              const gstAmount =
                row.taxType === "Without Tax"
                  ? (baseAmount * taxRate) / 100
                  : 0;

              const finalAmount = baseAmount + gstAmount;


              return (
                <tr key={row.id}>

                  <td className="text-center" style={{
                    minWidth: "160px",
                    position: "relative"
                  }}>
                    {index + 1}
                  </td>


                  {/* ITEM */}
                  <td style={{ minWidth: "280px", position: "relative" }}>
                    <div className="d-flex align-items-center gap-2">

                      <FaTrash
                        color="red"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setRows(rows.filter((_, i) => i !== index))
                        }
                      />



                      <Select
                        styles={{
                          ...reactSelectStyles("230px"),

                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 99999,
                          }),

                          menu: (base) => ({
                            ...base,
                            zIndex: 99999,
                          }),
                        }}

                        menuPortalTarget={document.body}
                        menuPosition="fixed"

                        options={itemOptions}

                        value={
                          row.itemId
                            ? itemOptions.find(x => x.value === row.itemId)
                            : null
                        }


onChange={(selected) => {
  if (!selected) return;

  const selectedInventoryItem = inventory.find(
    (item) => item.id === selected.value
  );

  if (!selectedInventoryItem) return;

  handleSelectItem(
    selectedInventoryItem,
    index
  );
}}

                        placeholder="Select Item"
                        isSearchable
                      />

                    </div>
                  </td>



                  {/* CATEGORY */}
                  <td style={{ minWidth: "160px", position: "relative" }}>

                    <Select
                      styles={selectPortalStyles("150px")}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      options={
                        category.map(cat => ({
                          value: cat.cat_name,
                          label: cat.cat_name
                        }))
                      }
                      value={
                        row.category
                          ?
                          {
                            value: row.category,
                            label: row.category
                          }
                          : null
                      }
                      onChange={(e) =>
                        handleRowChange(index, "category", e.value)
                      }
                      placeholder="Category"
                    />

                  </td>

                  {/* UNIT */}
                  <td style={{ minWidth: "130px", position: "relative" }}>

                    <Select
                      // styles={reactSelectStyles("120px")}
                      styles={selectPortalStyles("120px")}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      options={
                        unit.map(u => ({
                          value: u.cat_name,
                          label: u.cat_name
                        }))
                      }
                      value={
                        row.unit
                          ?
                          {
                            value: row.unit,
                            label: row.unit
                          }
                          : null
                      }
                      onChange={(e) =>
                        handleRowChange(index, "unit", e.value)
                      }
                      placeholder="Unit"
                    />

                  </td>



                  {/* PRICE */}
                  <td style={{ minWidth: "130px", position: "relative" }}>

                    <input
                      className="form-control form-control-sm text-center"
                      type="number"
                      min="0"
                      value={row.pur_price || 0}
                      onChange={(e) =>
                        handleRowChange(
                          index,
                          "pur_price",
                          Number(e.target.value)
                        )
                      }
                    />

                  </td>




                  {/* QTY */}
                  <td style={{ minWidth: "70px", width: "70px", position: "relative" }}>

                    <input
                      className="form-control form-control-sm text-center"
                      type="number"
                      min="1"
                      value={row.qty || 0}
                      onChange={(e) =>
                        handleRowChange(
                          index,
                          "qty",
                          Number(e.target.value)
                        )
                      }
                    />

                  </td>


                  <td style={{ minWidth: "270px", position: "relative" }}>

                    <div className="d-flex gap-2">

                      <Select
                        styles={selectPortalStyles("150px")}
                        options={[
                          { value: "With Tax", label: "With Tax" },
                          { value: "Without Tax", label: "Without Tax" }
                        ]}
                        value={{
                          value: row.taxType || "Without Tax",
                          label: row.taxType || "Without Tax"
                        }}
                        onChange={(e) =>
                          handleRowChange(index, "taxType", e.value)
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />


                      <Select

                        styles={selectPortalStyles("140px")}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        options={[
                          "GST-0",
                          "IGST-0",
                          "GST-0.25",
                          "IGST-0.25",
                          "GST-3",
                          "IGST-3",
                          "GST-5",
                          "IGST-5",
                          "GST-12",
                          "IGST-12",
                          "GST-18",
                          "IGST-18",
                          "GST-28",
                          "IGST-28",
                        ].map(t => ({
                          value: t,
                          label: t.replace("-", " ")
                        }))}
                        // value={
                        //   {
                        //     value: `${row.taxMode || "GST"}-${row.taxRate || ""}`,
                        //     label: `${row.taxMode || "GST"} ${row.taxRate || 0}%`
                        //   }
                        // }
                        value={
  row.taxRate !== undefined && row.taxRate !== ""
    ? {
        value: `${row.taxMode || "GST"}-${row.taxRate}`,
        label: `${row.taxMode || "GST"} ${row.taxRate}%`,
      }
    : null
}
                        onChange={(e) => {

                          const [taxMode, taxRate] = e.value.split("-");

                          handleRowChange(index, "taxMode", taxMode);
                          handleRowChange(index, "taxRate", Number(taxRate));

                        }}
                      />


                    </div>

                  </td>

                  {/* AMOUNT */}
                  <td className="fw-bold text-center">
                    ₹ {finalAmount.toFixed(2)}
                  </td>


                </tr>
              )

            })}
          </tbody>
        </table>

        <div
          style={{
            textAlign: "center",
            marginTop: "3px",
          }}
        >
          <FaPlusCircle
            size={35}
            color="var(--primary-color)"
            style={{ cursor: "pointer" }}
            onClick={addRow}
          />
        </div>
      </div>
  </div>

  <div className="container-fluid mt-3 mb-3">
   <div className="row text-center fw-bold"
        style={{
          background: "var(--primary-color)",
          color: "#fff",
          margin: "12px",
          padding: "10px",

        }}
      >
        <div className="col-12 col-sm-6 col-lg-3">Total Qty: {totalQty}</div>

        <div className="col-12 col-sm-6 col-lg-3">
          Amount: ₹{totalAmount.toFixed(2)}
        </div>

        <div className="col-12 col-sm-6 col-lg-3">
          GST: ₹{totalGST.toFixed(2)}
        </div>

        <div className="col-12 col-sm-6 col-lg-3">
          Grand Total: ₹{grandTotal.toFixed(2)}
        </div>
      </div>
  </div>


  <div className="container-fluid mt-3 ">
   <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "15px",
        }}
      >
        <div
          style={{
            background: "#ece7e7",
            padding: "15px",
            borderRadius: "15px",
            width: "100%",
            maxWidth: "400px",
            height: "fit-content",
          }}
        >
          <div className="border rounded p-2 mb-3">

            <div className="d-flex align-items-center gap-2 flex-nowrap">

              <div className="fw-bold" style={{ whiteSpace: "nowrap", color: 'var(--primary-color)' }}>
                Discount :
              </div>

              <select
                className="form-select form-select-sm"
                value={discountTypeUI}
                onChange={(e) => setDiscountTypeUI(e.target.value)}
              >
                <option value="percent">Percent</option>
                <option value="amount">Amount</option>
              </select>

              <input
                type="number"
                className="form-control form-control-sm"
                value={discountValue}
                onChange={(e) => setDiscountValue(e.target.value)}
                placeholder="Discount"
              />


            </div>
          </div>

{/*
          {isCredit && (
            <div className="border rounded p-2">

              <div className="fw-bold mb-2">
                Payment Method
              </div>

              <select
                className="form-select form-select-sm"
                name="payment_method"
                value={formData.payment_method}

                onChange={(e) => {
                  handleInputChange(e);

                  if (e.target.value === "Cash") {
                    setSelectedBankId(0);
                  }
                }}
                disabled={editData}
              >
                <option value="">Select Method</option>
                <option value="UPI">UPI</option>
                <option value="Credit Card">Credit Card</option>
                <option value="Debit Card">Debit Card</option>
              </select>

            </div>
          )} */}
{isCredit && (
  <div className="border rounded p-2">

    <div className="fw-bold mb-2">
      Payment Method <span className="text-danger">*</span>
    </div>

    <select
      className="form-select form-select-sm"
      name="payment_method"
      value={formData.payment_method || ""}
      onChange={(e) => {
        setFormData((prev) => ({
          ...prev,
          payment_method: e.target.value,
        }));

        // Credit payment ke liye bank selection required nahi
        setSelectedBankId(0);
      }}
      disabled={editData}
    >
      <option value="">
        Select Method
      </option>

      <option value="UPI">
        UPI
      </option>

      <option value="Credit Card">
        Credit Card
      </option>

      <option value="Debit Card">
        Debit Card
      </option>
    </select>

  </div>
)}



          {isCredit && formData.payment_method &&
            formData.payment_method !== "Cash" && (
              <div className="mt-2">

                <div className="fw-bold mb-2">
                  Select Bank Account
                </div>


                <select
                  className="form-select form-select-sm"
                  value={selectedBankId || ""}
                  onChange={(e) => {

                    setSelectedBankId(Number(e.target.value));
                  }}
                     disabled={editData}
                >
                  <option value="">Select Bank</option>

                  {bankList.map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.account_holder} ({bank.bank_name})
                    </option>
                  ))}
                </select>

              </div>
            )}
        </div>



        <div
          style={{
            background: "#ece7e7",
            padding: "15px",
            borderRadius: "15px",
            width: "100%",
            maxWidth: "350px",
          }}
        >

          <div className="invoice-box">
            Payable Amount : ₹ {payableAmount.toFixed(2)}
          </div>


          <div className="invoice-box d-flex align-items-center gap-2">
            <input
              type="checkbox"
              checked={isFullyPaid}
              onChange={(e) => {
                const checked = e.target.checked;
                setIsFullyPaid(checked);

                if (checked) {
                  setPaidAmount(payableAmount);
                }
              }}
            />

            <span>Paid Amount :</span>

            <input
              type="number"
              value={paidAmount}
              min="0"
              max={payableAmount}
              onChange={(e) => {
                const value = Number(e.target.value);

                setPaidAmount(value);
                setIsFullyPaid(value === payableAmount);
              }}
              style={{
                width: "120px",
                padding: "4px",
              }}
            />
          </div>


          <div
            className="invoice-box"
            style={{ color: "red", fontWeight: "bold" }}
          >
            Due Amount : ₹ {(payableAmount - paidAmount).toFixed(2)}
          </div>
        </div>


      </div>
  </div>


      <div
        className="footer-buttons"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "15px",
          flexWrap: "wrap",
          padding: "20px",
        }}
      >
        <button
          type="button"
          className="btn-clear"
          onClick={() => resetForm()}
        >
          Clear Bill
        </button>
        <button className="btn-save" onClick={handleSaveAndPrint} >{editData? 'Update Bill' : 'Save & Print' }</button>
        {!editData && (
               <button className="btn-preview" onClick={handleSaveAndPrint} >Preview & Share</button>
        )}



      </div>

    {showPartyForm && (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    aria-modal="true"
    style={{
      backgroundColor: "rgba(0, 0, 0, 0.55)",
    }}
  >
    <form onSubmit={handleSubmit}>
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg px-2">
        <div className="modal-content border-0 shadow-lg rounded-4">

          {/* =====================================================
              HEADER
          ====================================================== */}
          <div className="modal-header px-4 py-3">

            <h5
              className="modal-title fw-bold mb-0"
              style={{
                color: "#2583e8",
              }}
            >
              {isEditMode ? "Edit Party" : "Party Details"}
            </h5>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setShowPartyForm(false);
                setIsEditMode(false);
                resetForm();
              }}
            />

          </div>


          {/* =====================================================
              BODY
          ====================================================== */}
          <div className="modal-body px-4 py-3">

            <div className="row g-3">

              {/* =================================================
                  LEFT SECTION
              ================================================== */}
              <div className="col-12 col-md-6">

                {/* PARTY NAME */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    Party Name :
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />

                </div>


                {/* PARTY CONTACT */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    Party Contact :
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />

                </div>


                {/* PARTY GSTIN */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    Party GSTIN :
                  </label>
{/*
                  <input
                    type="text"
                    className="form-control"
                    name="gstin"
                    value={formData.gstin}
                    onChange={handleInputChange}
                  /> */}
                  <input
  type="text"
  className="form-control"
  name="gstin"
  value={formData.gstin}
  onChange={handleInputChange}
  disabled={formData.gst_type === "Unregistered"}
/>

                </div>


                {/* PARTY EMAIL */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    Party Email :
                  </label>

                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />

                </div>


                {/* TOTAL PURCHASE */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    Total Purchase :
                  </label>

                  <div className="form-control bg-light">
                    {formData.total_pur || 0}
                  </div>

                </div>


                {/* OPENING BALANCE */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    Opening Bal :
                  </label>

                  <input
                    type="number"
                    className="form-control"
                    name="opening_balance"
                    value={formData.opening_balance}
                    onChange={handleInputChange}
                    disabled={isEditMode}
                  />

                </div>

              </div>


              {/* =================================================
                  RIGHT SECTION
              ================================================== */}
              <div className="col-12 col-md-6">

                {/* GST TYPE */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    GSTIN Type :
                  </label>
<select
  className="form-select"
  name="gst_type"
  value={formData.gst_type}
  onChange={handleInputChange}
>
  <option value="">Select</option>

  <option value="Registered">
    Registered
  </option>

  <option value="Unregistered">
    Unregistered
  </option>
</select>

                </div>


                {/* GST STATE */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    GSTIN State :
                  </label>

                  {/* <input
                    type="text"
                    className="form-control"
                    name="gst_state"
                    value={formData.gst_state}
                    onChange={handleInputChange}
                  /> */}
                  <input
  type="text"
  className="form-control"
  name="gst_state"
  value={formData.gst_state}
  onChange={handleInputChange}
  disabled={formData.gst_type === "Unregistered"}
/>

                </div>


                {/* GST ADDRESS */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    GSTIN Address :
                  </label>

               <textarea
  className="form-control"
  name="address"
  value={formData.address}
  onChange={handleInputChange}
  rows="3"
  disabled={formData.gst_type === "Unregistered"}
/>

                </div>


                {/* TOTAL DUE - EDIT MODE */}
                {isEditMode && (
                  <div className="mb-3">

                    <label className="form-label fw-semibold text-danger mb-1">
                      Total Due :
                    </label>

                    <input
                      type="number"
                      className="form-control bg-light text-danger fw-semibold"
                      name="total_due"
                      value={formData.total_due || 0}
                      disabled
                    />

                  </div>
                )}


                {/* AS OF DATE - ADD MODE */}
                {!isEditMode && (
                  <div className="mb-3">

                    <label className="form-label fw-semibold mb-1">
                      As Of Date :
                    </label>

                    <input
                      type="datetime-local"
                      className="form-control"
                      name="asOfDate"
                      value={formData.asOfDate}
                      onChange={handleInputChange}
                      required
                    />

                  </div>
                )}

              </div>

            </div>

          </div>


          {/* =====================================================
              FOOTER
          ====================================================== */}
         {/* =====================================================
    FOOTER
===================================================== */}
<div className="border-top px-4 py-3">

  <div className="row align-items-center justify-content-between">

    {/* LEFT - CLOSE */}
    <div className="col-auto">
      <button
        type="button"
        className="btn btn-secondary px-4"
        onClick={() => {
          setShowPartyForm(false);
          setIsEditMode(false);
          resetForm();
        }}
      >
        Close
      </button>
    </div>


    {/* RIGHT - SUBMIT / UPDATE */}
    <div className="col-auto">
      <button
        type="submit"
        className="btn btn-primary px-4"
      >
        {isEditMode
          ? "Update Details"
          : "Submit Details"}
      </button>
    </div>

  </div>

</div>

        </div>
      </div>
    </form>
  </div>
)}



      {showPartyModal && (
        <div
          className="modal show fade d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content shadow-lg border-0 rounded-3">


              <div className="modal-header  text-white" style={{ backgroundColor: 'var(--primary-color)' }}>
                <h5 className="modal-title text-white">Select Party</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowPartyModal(false)}
                />
              </div>


              <div className="modal-body">

                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Search by name, mobile, GST..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />


                <div
                  className="list-group"
                  style={{ maxHeight: "350px", overflowY: "auto" }}
                >
                  {filteredParty.length > 0 ? (
                    filteredParty.map((p) => (
                      <button
                        key={p.id}
                        type="button"
                        className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                        onClick={() => {
                          setSelectedParty(p);
                          setShowPartyModal(false);
                        }}
                      >
                        <div>
                          <div className="fw-bold">{p.name}</div>
                          <small className="text-muted">
                            {p.mobile} | GST: {p.gstin || "NA"}
                          </small>
                        </div>

                        <span className="badge bg-success">
                          Select
                        </span>
                      </button>
                    ))
                  ) : (
                    <div className="text-center text-muted py-3">
                      No party found
                    </div>
                  )}
                </div>
              </div>


              <div className="modal-footer">
                <button
                  className="btn-credit"
                  onClick={() => setShowPartyModal(false)}
                >
                  Close
                </button>
              </div>

            </div>
          </div>
        </div>
      )}


{/* =========================================================
    ADD / EDIT PARTY MODAL
    ONLY ONE PARTY FORM MODAL
========================================================= */}

{showPartyForm && (
  <div className="party-modal-overlay">

    <form onSubmit={handleSubmit}>

      <div className="party-details-modal">

        {/* ================= HEADER ================= */}

        <button
          type="button"
          className="close-btn"
          onClick={() => {
            setShowPartyForm(false);
            setIsEditMode(false);
            resetFormParty();
          }}
        >
          ×
        </button>

        <h2 className="modal-title">
          {isEditMode ? "EDIT PARTY" : "ADD PARTY"}
        </h2>

        <h3>Enter Party Details:</h3>


        {/* ================= PARTY DETAILS ================= */}

        <div className="party-details-grid">

          {/* ================= LEFT ================= */}

          <div className="details-column">

            <div className="detail-row">
              <label>Party Name :</label>

              <input
                type="text"
                name="name"
                value={formData.name || ""}
                onChange={handleInputChange}
                placeholder="Enter Name"
                required
              />
            </div>


            <div className="detail-row">
              <label>Party Contact :</label>

              <input
                type="text"
                name="mobile"
                value={formData.mobile || ""}
                onChange={handleInputChange}
                placeholder="Enter Number"
                maxLength={10}
                required
              />
            </div>


            <div className="detail-row">
              <label>Party GSTIN :</label>

              <input
                type="text"
                name="gstin"
                value={formData.gstin || ""}
                onChange={handleInputChange}
                placeholder="Enter GSTIN"
                disabled={
                  formData.gst_type === "Unregistered"
                }
              />
            </div>


            <div className="detail-row">
              <label>Party Email :</label>

              <input
                type="email"
                name="email"
                value={formData.email || ""}
                onChange={handleInputChange}
                placeholder="Enter Email"
              />
            </div>


            <div className="detail-row">
              <label>Total Purchase :</label>

              <span>
                {formData.total_pur || 0}
              </span>
            </div>


            <div className="detail-row">
              <label>Opening Bal :</label>

              <input
                type="number"
                name="opening_balance"
                value={
                  formData.opening_balance || ""
                }
                onChange={handleInputChange}
                placeholder="Opening Balance"
                disabled={isEditMode}
              />
            </div>

          </div>


          {/* ================= RIGHT ================= */}

          <div className="details-column">

            <div className="detail-row">

              <label>GSTIN Type :</label>

              <select
                name="gst_type"
                value={formData.gst_type || ""}
                onChange={handleInputChange}
              >

                <option value="">
                  Select
                </option>

                <option value="Registered">
                  Registered
                </option>

                <option value="Unregistered">
                  Unregistered
                </option>

              </select>

            </div>


            <div className="detail-row">

              <label>GSTIN State :</label>

              <input
                type="text"
                name="gst_state"
                value={formData.gst_state || ""}
                onChange={handleInputChange}
                placeholder="Enter State"
                disabled={
                  formData.gst_type === "Unregistered"
                }
              />

            </div>


            <div className="detail-row address-row">

              <label>GSTIN Address :</label>

              <textarea
                name="address"
                value={formData.address || ""}
                onChange={handleInputChange}
                placeholder="Enter Address"
                disabled={
                  formData.gst_type === "Unregistered"
                }
              />

            </div>


            {/* ================= TOTAL DUE ================= */}

            {isEditMode && (
              <div className="detail-row">

                <label className="text-danger">
                  Total Due :
                </label>

                <span className="text-danger">
                  ₹ {formData.total_due || 0}
                </span>

              </div>
            )}


            {/* ================= AS OF DATE ================= */}

            {!isEditMode && (
              <div className="detail-row">

                <label>As of Date :</label>

                <input
                  type="datetime-local"
                  name="asOfDate"
                  value={
                    formData.asOfDate || ""
                  }
                  onChange={handleInputChange}
                  required
                />

              </div>
            )}

          </div>

        </div>


        {/* ================= FOOTER ================= */}

        <div className="submit-area">

          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              setShowPartyForm(false);
              setIsEditMode(false);
              resetFormParty();
            }}
          >
            Close
          </button>

          <button
            type="submit"
            className="submit-btn"
          >
            {isEditMode
              ? "Update Details"
              : "Submit Details"}
          </button>

        </div>

      </div>

    </form>

  </div>
)}

</div>

  );
};

export default PurchaseReturn;